import {isNotEmpty} from "../../utils/strings";
import SideMenuItem from "./SideMenuItem";

const SideMenuList = (
  {
    ulClassName = "",
    titleClassname = "menu-title",
    title = "",
    title1 = "",
    title2 = "",
    menus = [],
    idPrefix = "",
    style = {},
    fontColor = "",
    titleFontColor = "",
  }) => {

  return (
    (menus && menus.length > 0) ?
      (
        <>
          {(isNotEmpty(title1) && isNotEmpty(title2)) &&
            <div className={"menu-title " + titleClassname}>
              {isNotEmpty(title1) &&
                <span className={"title1"} style={{color: titleFontColor}}>{title1}</span>
              }
              {isNotEmpty(title2) &&
                <span className={"title2"} style={{color: titleFontColor}}>{title2}</span>
              }
            </div>
          }
          <ul className={"top-menu " + ulClassName} style={style}>
            {isNotEmpty(title) &&
              <li className={titleClassname} style={{color: titleFontColor}}>{title}</li>
            }
            {menus.map((menu) =>
              <SideMenuItem
                key={idPrefix + menu.id}
                data-id={idPrefix + menu.id}
                menuElement={menu}
                fontColor={fontColor}
              />
            )}
          </ul>
        </>
      ) : (
        <></>
      )
  )
};
export default SideMenuList;